/**
 * Копирует указанный текст в буфер обмена
 * @param text Текст для копирования
 * @returns Promise, который разрешается, когда текст скопирован
 */
export const copyToClipboard = (text: string): Promise<void> => {
  return navigator.clipboard.writeText(text);
}; 